export const INVALID_CHARACTERS_REGEX = /\s/;

export type ValidatorFunction = (char: string) => boolean;

export type FormatterConfig = {
    data: string;
    patternSchema: string;
    previousData?: string | null | undefined;
    ignoreCase?: boolean | null | undefined;
    ignoreMaxLength?: boolean | null | undefined;
};

export function patternDataFormatter(config: FormatterConfig): string {
    if (!config.data) {
        return config.data ?? '';
    }
    if (!config.patternSchema) {
        return config.data;
    }
    let formattedData = '';
    let inputIndex = 0;
    const newData: string = config.data;

    const inputValidators: Record<string, ValidatorFunction> = {
        D: (char: string): boolean => /[A-Za-z]/.test(char),
        d: (char: string): boolean => /[A-Za-z]/.test(char),
        X: (char: string): boolean => /\d/.test(char),
        x: (char: string): boolean => /\d/.test(char),
    };
    const applyConfigOptions = (): void => {
        if (!config.ignoreCase) {
            formattedData = formattedData.toUpperCase();
        }
        if (!config.ignoreMaxLength) {
            formattedData = formattedData.slice(0, config.patternSchema.length);
        }
    };
    const skipInvalidCharacter = (char: string): void => {
        if (!INVALID_CHARACTERS_REGEX.test(char)) {
            while (
                inputIndex < newData.length &&
                INVALID_CHARACTERS_REGEX.test(newData[inputIndex])
            ) {
                inputIndex++;
            }
        }
    };
    const isDeleting: boolean = !!(
        config?.previousData && newData.length < config?.previousData?.length
    );

    for (const pattern of config.patternSchema) {
        if (inputValidators[pattern]) {
            skipInvalidCharacter(pattern);
            if (inputIndex >= newData.length) {
                break;
            }
            const currentCharacter = newData[inputIndex];
            if (!inputValidators[pattern](currentCharacter)) {
                if (newData[inputIndex - 1] === newData[inputIndex]) {
                    formattedData = newData.substring(0, inputIndex);
                    applyConfigOptions();
                    return formattedData;
                } else {
                    formattedData = <string>newData;
                    applyConfigOptions();
                    return formattedData;
                }
            }
            formattedData += currentCharacter;
            inputIndex++;
        } else {
            skipInvalidCharacter(pattern);
            if (inputIndex < newData.length && newData[inputIndex] === pattern) {
                formattedData += pattern;
                inputIndex++;
            } else if (!isDeleting) {
                formattedData += pattern;
            }
        }
    }

    if (inputIndex < newData.length) {
        formattedData += newData.slice(inputIndex);
    }
    applyConfigOptions();
    return formattedData;
}

export const formatField = (
    strInput: string,
    format: string,
    previousInput?: string | null | undefined
) => {
    return patternDataFormatter({
        data: strInput,
        patternSchema: format,
        previousData: previousInput,
        ignoreMaxLength: true,
    });
};
